let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c0zXU")).then(() => parcelRequire('3eG9z'));